module.exports = __webpack_public_path__ + "img/artikelen.86042a55.png";